const updateRelatedProduct = data => {
  return {
    type: 'UPDATE:RELATED:PRODUCT',
    data
  }
}

export default {
  updateRelatedProduct
}
